<template>
  <div class="video" @pointermove.prevent="handleMouseMove($event)"
       @pointerup.prevent="stopDragging"
       @pointerleave="handleMouseLeave"
       @pointerenter="handleMouseEnter" ref="vcontainer">
    <video class="video__player"  ref="v" @timeupdate="handleTimeUpdate" @waiting="waiting" @error="error" @ended="handleEnd" id="videos">
      <source :src="videoSrc" :key='videoSrc' />
    </video>
    <!-- 加载动画   -->
    <div class="video_loading" v-show="loading">
      <img src="@/assets/img/Loading.gif" />
    </div>

    <!--  下一节视频    v-show="is_next" -->
    <div class="video_next" v-show="is_next">
      <div class="next_button" @click.stop="toggleNextSection()">下一节</div>
      <el-button class="next_button_su" v-if="!sub_loading" :loading="sub_loading" @click.stop="toggleSubmitLog()">提交本节视频学习记录</el-button>
      <el-button class="next_button_su_no" v-else :loading="sub_loading">提交数据中</el-button>
      <div class="next_again" @click.stop="toggleNextAgain"><span class="el-icon-refresh"></span>重新观看</div>
    </div>

    <div class="controller" v-show="isControlVisible">
      <!--  进度条    -->
      <div class="controller__progress-wrapper">
        <div class="controller__progress" ref="p" @click="handleProgressClick($event)">
          <div class="controller__progress controller__progress--passed"
               :style="{width: videoProgressPercent}"></div>
          <div class="controller__dot"
               :style="{left: videoProgressPercent}"
               @pointerdown="startDragging($event)">
            <div class="controller__inner-dot"></div>
          </div>
        </div>
      </div>
      <div class="controller__btn-wrapper">
        <!--    开始/暂停    -->
        <div class="controller__btn" @click="togglePlaying">
          <font-awesome-icon :icon="['fas', 'play']" v-if="isPaused"></font-awesome-icon>
          <font-awesome-icon :icon="['fas', 'pause']" v-else></font-awesome-icon>
        </div>
        <!--    静音按钮    -->
        <div class="controller__btn" @click="toggleMute">
          <font-awesome-icon :icon="['fas', 'volume-mute']"
                             v-if="isMuted"></font-awesome-icon>
          <font-awesome-icon :icon="['fas', 'volume-up']" v-else></font-awesome-icon>
        </div>
        <!--  播放时长      -->
        <div class="controller__timer">
          {{videoTime}}
        </div>
        <!--    全屏    -->
        <div class="controller__btn controller__btn--fullscreen" @click="toggleFullscreen">
          <font-awesome-icon :icon="['fas', 'expand']"></font-awesome-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    function secToTimer(originalSec) {
        const min = Math.floor(originalSec / 60);
        const sec = Math.floor(originalSec % 60);
        const minStr = min < 10 ? `0${min}` : String(min);
        const secStr = sec < 10 ? `0${sec}` : String(sec);
        return `${minStr}:${secStr}`;
    }

    export default {
        name: "MyVideo",
        props: {
            videoSrc:{
                type:String,
                default:""
            },
            //是否允许快进操作
            isFast:{
                type:Number,
                default:2
            },
            //当前播放进度
            logTime:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                video: null,
                isPaused: true,
                isMuted: false,
                videoTime: '00:00 / 00:00',
                isDragging: false,
                isControlVisible: false,
                hidingEvent: null,
                videoProgress: 0,
                draggingStartX: 0,
                dotOffsetX: 0,
                progress: null,
                loading:true,//加载动画
                is_next:false,//下一节/重新观看
                sub_loading:false,
            };
        },
        watch: {
            videoSrc:{
                handler (newV, oldV) {
                    this.videoSrc = newV
                    this.loading = true
                    let dom = document.getElementById('videos')
                    dom.src = newV
                    dom.currentTime = this.logTime
                    this.togglePlaying()
                    this.is_next = false
                },
                deep:true
            },
            isFast:{
                handler (newV, oldV) {
                    this.isFast = newV
                },
                deep:true
            }

        },
        computed: {
            videoProgressPercent() {
                return `${this.videoProgress * 100}%`;
            },
        },
        methods: {
            error(){
                this.$notify({
                    title: '提示',
                    message: '抱歉，当前视频源已损坏',
                    type: 'warning'
                });
                this.pauseVideo()
                this.loading = false
            },
            waiting(){
                this.loading = true
            },
            toggleFullscreen() {
                const isFullscreen = document.webkitIsFullScreen || document.fullscreen;
                if (isFullscreen) {
                    const exitFunc = document.exitFullscreen || document.webkitExitFullscreen;
                    exitFunc.call(document);
                } else {
                    const element = this.$refs.vcontainer;
                    const fullscreenFunc = element.requestFullscreen || element.webkitRequestFullScreen;
                    fullscreenFunc.call(element);
                }
            },
            //更新视频时长进度
            handleTimeUpdate() {
                this.videoProgress = this.video.currentTime / this.video.duration;
                if(this.video.currentTime>0){
                    this.loading = false
                }
                this.videoTime = this.refreshTime();
                this.$emit("postuserCourselog",this.video.currentTime,this.video.duration)
            },
            refreshTime() {
                if (!this.video) {
                    return `${secToTimer(0)} / ${secToTimer(0)}`;
                }
                const currTime = this.video.currentTime || 0;
                const duration = this.video.duration || 0;
                return `${secToTimer(currTime)} / ${secToTimer(duration)}`;
            },
            //重新观看
            toggleNextAgain(){
                this.playVideo()
                this.is_next = !this.is_next
            },
            //下一节
            toggleNextSection(){
                this.$emit("getNextSection")
                this.is_next = !this.is_next
            },
            togglePlaying() {
                if (this.video.paused) {
                    this.playVideo();
                } else {
                    this.pauseVideo();
                }
            },
            toggleMute() {
                this.video.muted = !this.video.muted;
                this.isMuted = this.video.muted;
            },
            //提交本节视频课的播放记录  (两个方法中其中一个方法，避免监听结束的函数时提交的网络不稳定，没有数据)
            toggleSubmitLog(){
                let currentTime =  this.video.currentTime
                this.sub_loading = true
                this.$emit("userCourseByOver",currentTime,1)
            },
            Suloading(){
                this.sub_loading = false
            },
            //播放结束
            handleEnd() {
                this.pauseVideo();
                this.is_next = true
                let currentTime =  this.video.currentTime
                this.$emit("userCourseByOver",currentTime,2)
            },
            playVideo() {
                this.isPaused = false;
                this.video.play();
            },
            pauseVideo() {
                this.isPaused = true;
                this.video.pause();

            },
            setProgress(x) {
                const progressRect = this.progress.getBoundingClientRect();
                let progressPercent = (x - progressRect.left) / progressRect.width;
                if (progressPercent < 0) {
                    progressPercent = 0;
                } else if (progressPercent > 1) {
                    progressPercent = 1;
                }
                this.video.currentTime = this.video.duration * progressPercent;
                this.handleTimeUpdate()
            },
            hideControlBar() {
                const isFullscreen = document.webkitIsFullScreen || document.fullscreen;
                if (isFullscreen) {
                    this.hideCursor();
                }
                this.isControlVisible = false;
            },
            showControlBar() {
                this.isControlVisible = true;
            },
            hideCursor() {
                document.body.style.cursor = 'none';
            },
            showCursor() {
                document.body.style.cursor = 'default';
            },
            //轻点进度条任意部分时，视频会跳到被点击的时间点
            handleProgressClick(event) {
                let isFast = this.isFast
                if(isFast==2){
                    this.$message({
                        showClose: true,
                        message: '当前课程不允许快进学习哦～',
                        type: 'warning'
                    });
                    return
                }
                const clickX = event.clientX;
                this.setProgress(clickX);
            },
            //拖动进度条时视频的播放时间会实时改变
            startDragging(event) {
                let isFast = this.isFast
                if(isFast==2){
                    this.$message({
                        showClose: true,
                        message: '当前课程不允许快进学习哦～',
                        type: 'warning'
                    });
                    return
                }
                this.pauseVideo();
                this.isDragging = true;
                this.draggingStartX = event.clientX;
            },
            moveDragging(event) {
                if (this.isDragging) {
                    const offsetX = event.clientX - this.draggingStartX;
                    this.dotOffsetX = offsetX < 0 ? 0 : offsetX;
                    this.setProgress(event.clientX);
                }
            },
            stopDragging() {
                this.isDragging = false;
                this.dotOffsetX = 0;
            },
            handleMouseMove(event) {
                this.showControlBar();
                this.showCursor();
                if (this.hidingEvent !== null) {
                    clearInterval(this.hidingEvent);
                }
                //3秒内用户完全没有动作时控制条会被隐藏。
                this.hidingEvent = setInterval(this.hideControlBar, 3000);
                this.moveDragging(event);
            },
            handleMouseLeave() {
                this.hideControlBar();
                this.stopDragging();
            },
            handleMouseEnter() {
                this.showControlBar();
            },
        },
        mounted() {
            this.video = this.$refs.v;
            this.progress = this.$refs.p;
        },
    };
</script>

<style lang="scss" scoped>
  .video {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #000000;
    .video_loading{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 200px;
      height: 150px;
      margin:auto;
      z-index: 999;
      img{
        width: 200px;
        height: 150px;
        margin: 0 auto;
        border-radius: 10%;
      }
    }
    .video_next{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      width: 500px;
      height: 100px;
      margin:auto;
      z-index: 99;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .next_button{
        width: 110px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #3ab06f;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 50px;
        margin-right: 20px;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
      .next_button_su{
        border: none;
        padding: 0 !important;
        width: 175px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #66b1ff;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 50px;
        margin-right: 20px;
        margin-left: 20px;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
      .next_button_su_no{
        border: none;
        padding: 0 !important;
        width: 175px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #999;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        border-radius: 50px;
        margin-right: 20px;
        margin-left: 20px;
        cursor: pointer;
        &:hover{
          opacity: 0.7;
        }
      }
      .next_again{
        font-size: 16px;
        cursor: pointer;
        color: #999;
        &:hover{
          color: #3ab06f;
        }
      }
    }
  }

  .video__player {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .controller {
    flex-direction: column;
    height: 50px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  .controller__btn-wrapper {
    position: relative;
    height: calc(100% - 5px);
    display: flex;
    align-items: center;
    color: #fff;
    padding: 0 18px;
  }

  .controller__btn {
    cursor: pointer;
    transition: 0.5s;
    margin: 0 20px;
  }

  .controller__btn:hover {
    color: #40af71;
  }

  .controller__timer {
    margin-left: 15px;
  }

  .controller__btn--fullscreen {
    position: absolute;
    right: 15px;
  }

  .controller__progress-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .controller__progress {
    height: 5px;
    position: relative;
    width: calc(100% - 30px);
    border-radius: 100px;
    background: #dcdcdc;
    cursor: pointer;
  }

  .controller__progress--passed {
    position: absolute;
    top: 0;
    left: 0;
    background: #40af71;
    transition: all .1s
  }

  .controller__dot {
    position: absolute;
    z-index: 50;
    left: 0;
    top: -5px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .controller__inner-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #40af71;
  }
</style>
